"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLineheightSelects = addLineheightSelects;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _hsformatting = require("tinymce-plugins/constants/hsformatting");

var _TinyMceLineHeight = _interopRequireDefault(require("../components/toolbar/TinyMceLineHeight"));

var _utils = require("../utils");

var _formatting = require("../utils/formatting");

var _usageTracking = require("../constants/usageTracking");

var _usageTracking2 = require("../utils/usageTracking");

var _utils2 = require("./utils");

var _hsformatting2 = require("../constants/hsformatting");

var _toolbar = require("../constants/toolbar");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting2.i18nNameSpace);

function registerLineHeightFormat(_ref) {
  var editor = _ref.target;
  editor.formatter.register(_hsformatting2.LINE_HEIGHT_FORMAT, {
    selector: 'p,h1,h2,h3,h4,h5,h6,ul,div',
    styles: {
      lineHeight: '%value'
    }
  });
}

function createLineHeightSelectMenu(editor, lineHeights) {
  var lineHeightSelectMenuOnClick = function lineHeightSelectMenuOnClick(event) {
    var lineHeight = event.control.settings.format;

    if (lineHeight) {
      var lineHeightApplied = (0, _utils2.applyLineHeight)(editor, lineHeight);
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_LINE_HEIGHT, {
        value: lineHeightApplied.toString(),
        method: 'menu'
      });
    }
  };

  return lineHeights.map(function (item) {
    return {
      text: item.toString(),
      format: item,
      onclick: lineHeightSelectMenuOnClick
    };
  });
}

function createListBoxChangeHandler(items, formatName, editor) {
  var valueMatcher = (0, _formatting.getMatchingValueHandler)(editor, formatName, items);
  return function (_ref2) {
    var control = _ref2.control;
    editor.on('NodeChange', function (e) {
      var currentControlValue = control.value();
      var newControlValue = valueMatcher(e);

      if (currentControlValue === newControlValue) {
        return;
      }

      control.value(newControlValue);
    });
  };
}

function addLineheightSelects(editor) {
  editor.on('PreInit', registerLineHeightFormat);
  var lineheights = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.LINE_HEIGHTS, []);
  var items = lineheights.map(function (value) {
    return {
      text: {
        raw: value.toString()
      },
      value: value
    };
  });
  editor.addButton('lineheight', function () {
    return {
      type: 'listbox',
      classes: 'lineheight',
      icon: 'lineheight',
      tooltip: i18nKey('lineHeightToolbarButton'),
      onPostRender: createListBoxChangeHandler(items, 'line_height', editor),
      menu: items,
      onselect: function onselect(event) {
        var lineHeight = event.control.settings.value;

        if (lineHeight) {
          var lineHeightApplied = (0, _utils2.applyLineHeight)(editor, lineHeight);
          (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_LINE_HEIGHT, {
            value: lineHeightApplied.toString(),
            method: 'toolbar'
          });
        }
      }
    };
  });
  editor.addMenuItem('lineheight', {
    text: i18nKey('lineHeightMenuItem'),
    menu: createLineHeightSelectMenu(editor, lineheights)
  });
  editor.addButton('canvaslineheight', function () {
    return {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_TinyMceLineHeight.default, (0, _extends2.default)({
          editor: editor,
          lineHeights: items,
          tooltip: i18nKey('lineHeightToolbarButton'),
          onChange: function onChange(value) {
            var lineHeightApplied = (0, _utils2.applyLineHeight)(editor, value);
            (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_LINE_HEIGHT, {
              value: lineHeightApplied.toString(),
              method: 'toolbar',
              version: 'v2'
            });
          }
        }, props));
      }
    };
  });
}